<template>
    <div id="app"> 
    <!-- CHAMADA DO TOOLBAR -->    
    <!-- CHAMADA DO TOOLBAR -->
    <v-app>      
      <Toolbar />
        <v-main>           
            <!-- CHAMADA DO CONTEUDO -->          
            <Content />                              
        </v-main>
      <!-- CHAMADA DO FOOTER -->
      <Footer />
      <!-- CHAMADA DO FOOTER -->
      <!-- Aceite de contrato no 1º acesso -->
      <ContratoDialog />
      <!-- Ativação da assinatura (pagamento) após o aceite -->
      <AssinaturaDialog />
    </v-app>
</div>
</template>

<script>
    import Footer from '../componentes/footer.vue'
    import Toolbar from '../componentes/toolbar.vue'
    import Content from '../componentes/content.vue'
    import ContratoDialog from '../componentes/ContratoDialog.vue'
    import AssinaturaDialog from '../componentes/AssinaturaDialog.vue'
    import { mapState } from "vuex"
    export default {
    name: 'app',
    components: {Footer, Toolbar, Content, ContratoDialog, AssinaturaDialog},
    computed: {
       ...mapState({
        usuarioadmin: state => state.Userpermission,
    })
    },
    data () {
    return {
    }
    },

}
</script>

<style>
    @font-face {
     font-family: Roboto;
     src: url('https://fonts.google.com/specimen/Roboto');
    }
#app {	
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;

    background: #F4F7F6;
}

#app h1 {
	text-align: center;
	margin: 50px;
}

html{
    overflow: auto;
    }

.v-tabs-bar.v-item-group {
  height: 38px;
}

.v-tab--active {
  background-color: white !important;
  color: grey !important;
  border-radius: 5px 5px 0 0 !important;
}

.v-tab {
  border-radius: 5px 5px 0 0;
  background-color: #00253E;
  color: white;
}

@media only screen and (min-width: 550px) {
  .v-tab {
    min-width: 130px;
  }
  
  .v-tabs-bar.v-item-group {
    max-width: 400px;
  }
  
  .v-tab:nth-child(3) {
    border-radius: 0 5px 0 0;
  }

  .v-tab:nth-child(2) {
    border-radius: 5px 0 0 0;
  }
  
  .v-tabs-bar.v-item-group {
    background-color: #00253E !important;
    border-radius: 10px 10px 0 0;
    color: white;
  }
}

.theme--dark.v-tabs>.v-tabs-bar .v-tab--disabled, .theme--dark.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active), .theme--dark.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon {
  color: white;
}

/* abas no modo escuro: evita o branco/azul-claro chapado do tema claro */
.theme--dark .v-tab--active { background-color: #152420 !important; color: #eaf2ef !important; }
.theme--dark .v-tab { background-color: #11201b; color: #dfe7e4; }
.theme--dark .v-tabs-bar.v-item-group { background-color: #11201b !important; }

.theme--dark.v-tabs .v-tab--active:before, .theme--dark.v-tabs .v-tab--active:hover:before, .theme--dark.v-tabs .v-tab:focus:before {
  opacity: 0;
}

.v-tabs-slider {
  display: none;
}


</style>
